import React from "react";

const RELATIVE = (ts) => {
  if (!ts) return "just now";
  const d = new Date(ts);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  return d.toLocaleDateString();
};

const fmtDur = (ms) => {
  const s = Math.round((ms || 0) / 1000);
  return s > 0 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}` : null;
};

export const sessionTypeOf = (p) => (p.beat_source ? "beat" : "vocal");

// One row in Drafts & Recent Sessions — scan-friendly metadata chips.
export const StudioSessionCard = ({ project: p, onOpen }) => {
  const isBeat = sessionTypeOf(p) === "beat";
  const beatName = p.beat_ref?.title || (p.beat_source === "upload" || p.beat_ref?.upload_url ? "Uploaded beat" : null);
  const bpm = p.beat_ref?.bpm;
  const license = p.license_state === "owned" ? "Licensed" : p.license_state === "user_upload" ? "Your beat" : null;
  const mastered = p.master && p.master.preset && p.master.preset !== "off";
  const dur = fmtDur(p.duration_ms);
  return (
    <button type="button" onClick={onOpen} className="w-full text-left group" data-testid={`studio-open-${p.project_id}`}>
      <div className="flex items-center gap-3 p-3 rounded-xl bg-white/[0.03] border border-white/10 group-hover:border-fuchsia-400/40 transition-colors">
        {(p.cover_url || p.beat_ref?.cover_url) ? (
          <img src={p.cover_url || p.beat_ref.cover_url} alt="" className="w-11 h-11 shrink-0 rounded-lg object-cover border border-white/10" />
        ) : (
        <div className={`w-11 h-11 shrink-0 rounded-lg flex items-center justify-center text-[10px] font-black tracking-wider ${
          isBeat ? "bg-gradient-to-br from-fuchsia-600 to-purple-800 text-white" : "bg-white/[0.06] text-gray-300 border border-white/10"
        }`}>
          {isBeat ? "BEAT" : "NEW"}
        </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="font-semibold truncate">{p.title || "Untitled Session"}</p>
          <div className="flex flex-wrap items-center gap-1.5 mt-1 text-[10px]">
            <span className={`px-1.5 py-0.5 rounded font-bold ${isBeat ? "bg-fuchsia-500/15 text-fuchsia-200" : "bg-white/5 text-gray-400"}`}
              data-testid={`studio-type-${p.project_id}`}>
              {isBeat ? "Beat session" : "No beat yet"}
            </span>
            {isBeat && beatName && <span className="text-gray-400 truncate max-w-[140px]">{beatName}</span>}
            {bpm && <span className="text-gray-500 tabular-nums">{`${bpm} BPM`}</span>}
            {license && <span className="text-gray-500">{license}</span>}
            {dur && <span className="text-gray-500 tabular-nums">{dur}</span>}
            {p.genre && <span className="text-gray-500">{p.genre}</span>}
            {mastered && <span className="px-1.5 py-0.5 rounded bg-amber-400/15 text-amber-200 font-bold">Mastered</span>}
            {p.access_role === "collaborator" && (
              <span className="px-1.5 py-0.5 rounded bg-emerald-500/15 text-emerald-200 font-bold" data-testid={`studio-shared-by-${p.project_id}`}>
                Shared by {p.owner?.name || "an artist"}
              </span>
            )}
            {(p.collaborator_count || 0) > 0 && (
              <span className="px-1.5 py-0.5 rounded bg-fuchsia-500/15 text-fuchsia-200 font-bold" data-testid={`studio-collab-count-${p.project_id}`}>
                {p.collaborator_count} collaborator{p.collaborator_count > 1 ? "s" : ""}
              </span>
            )}
          </div>
        </div>
        <p className="text-[10px] text-gray-500 shrink-0">{RELATIVE(p.last_opened_at || p.updated_at)}</p>
      </div>
    </button>
  );
};

export default StudioSessionCard;
